import { TableHead, TableRow, TableCell } from "@mui/material";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";


const UnActiveRequestsTableHead = () => {

    const headCells = [
        "",
        "Deo koji se trazi",
        "Postavljen",
        "Ponude",
        "Opis"
    ];


    return (
        <TableHead sx={{}}>
            <TableRow>
                {headCells.map((headCell, i) => (
                    <TableCell
                        key={i}
                        align={"left"}
                    >
                        <div>
                            <p style={styles.tableHeadText}>
                                {headCell}
                            </p>
                        </div>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
};

export default UnActiveRequestsTableHead;


const styles = {
    tableHeadText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "14px"
    }
}